var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,256.001c0-11.317-0.743-22.461-2.167-33.391H222.606C170.305,170.312,74.976,74.989,74.98,74.981 c-99.974,99.974-99.974,262.064,0,362.04l147.629-147.628h287.224C511.256,278.462,512,267.318,512,256.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M511.927,261.823c-0.011,0.494-0.022,0.99-0.036,1.484 C511.903,262.811,511.915,262.317,511.927,261.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M511.681,268.819c-0.023,0.489-0.057,0.976-0.083,1.464 C511.624,269.796,511.656,269.308,511.681,268.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M511.336,274.399c-0.051,0.719-0.101,1.438-0.159,2.155 C511.235,275.837,511.284,275.118,511.336,274.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M510.481,228.099c0.094,0.856,0.188,1.711,0.273,2.569 C510.669,229.809,510.574,228.955,510.481,228.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M511.597,241.718c0.027,0.488,0.06,0.975,0.083,1.464 C511.656,242.693,511.624,242.205,511.597,241.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M511.89,248.696c0.014,0.494,0.024,0.99,0.036,1.484C511.915,249.684,511.903,249.19,511.89,248.696 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M511.177,235.447c0.058,0.717,0.108,1.436,0.159,2.155 C511.284,236.883,511.235,236.164,511.177,235.447z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M509.833,222.609c0.115,0.877,0.217,1.759,0.322,2.638C494.961,98.365,386.975,0.001,256,0.001 c-70.694,0-134.695,28.655-181.022,74.984l147.624,147.625H509.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M509.833,289.392H222.602L74.978,437.017c46.327,46.328,110.328,74.984,181.022,74.984 c130.975,0,238.962-98.364,254.155-225.247C510.05,287.633,509.946,288.515,509.833,289.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M510.753,281.333c-0.085,0.858-0.179,1.713-0.273,2.569 C510.574,283.046,510.669,282.192,510.753,281.333z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M511.336,237.602c0.097,1.369,0.185,2.741,0.26,4.116C511.52,240.343,511.433,238.971,511.336,237.602z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M510.155,225.247c0.115,0.949,0.224,1.9,0.326,2.852C510.377,227.147,510.268,226.197,510.155,225.247z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M510.753,230.668c0.156,1.589,0.297,3.182,0.424,4.781C511.051,233.85,510.91,232.256,510.753,230.668z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512,256.001c0,1.947-0.03,3.886-0.073,5.821C511.97,259.886,512,257.947,512,256.001z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M511.597,270.283c-0.076,1.375-0.164,2.747-0.26,4.116C511.433,273.03,511.52,271.658,511.597,270.283z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M511.177,276.554c-0.127,1.597-0.268,3.191-0.424,4.779C510.91,279.745,511.051,278.151,511.177,276.554z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M510.481,283.902c-0.102,0.952-0.211,1.902-0.326,2.852C510.268,285.805,510.377,284.854,510.481,283.902z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M511.927,250.179c0.043,1.936,0.073,3.876,0.073,5.821C512,254.055,511.97,252.115,511.927,250.179z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M511.681,243.182c0.09,1.832,0.158,3.671,0.21,5.513C511.839,246.852,511.772,245.014,511.681,243.182z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M511.89,263.307c-0.052,1.842-0.12,3.681-0.21,5.513C511.772,266.987,511.839,265.149,511.89,263.307z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M511.756,244.778H213.201L59.844,91.444c-4.957,5.228-10.33,12.528-13.653,17.727L192.85,255.907 L46.068,402.692c2.906,5.17,9.237,12.822,13.682,17.801l153.454-153.454h298.588c0.159-3.692,0.209-7.4,0.209-11.13 C512,250.911,511.862,247.226,511.756,244.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M62.187,310.573V289.13c21.398,0,38.805-17.409,38.805-38.805c0-15.139-12.317-27.455-27.455-27.455 c-10.313,0-18.704,8.39-18.704,18.705c0,6.595,5.365,11.961,11.961,11.961c3.728,0,6.761-3.035,6.761-6.763h21.442 c0,15.553-12.652,28.205-28.202,28.205c-18.419,0.001-33.402-14.985-33.402-33.401c0-22.137,18.01-40.146,40.145-40.146 c26.962,0,48.898,21.936,48.898,48.897C122.435,283.545,95.408,310.573,62.187,310.573z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVu);
export default __webpack_public_path__ + "static/media/vu.c935bbf510ae8b1696110fa49da2d3e5.svg";
export { ForwardRef as ReactComponent };